import { render, staticRenderFns } from "./jb.vue?vue&type=template&id=7e2c26c4&scoped=true"
import script from "./jb.vue?vue&type=script&lang=js"
export * from "./jb.vue?vue&type=script&lang=js"
import style0 from "./jb.vue?vue&type=style&index=0&id=7e2c26c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2c26c4",
  null
  
)

export default component.exports